"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objTitle = exports.defaultObj = void 0;
// 商品默认数据对象
var defaultObj = exports.defaultObj = {
  // 基础信息
  id: undefined,
  name: '',
  intro: '',
  keyword: '',
  image: '',
  sliderImage: '',
  sliderImages: [],
  content: '',
  sort: 0,
  isShow: false,
  type: 0,
  // 商品类型
  unitName: '',
  brandId: '',
  cateIds: [],
  // 商品分类ID数组
  cateId: null,
  // 单个分类ID（用于提交）
  categoryId: 0,
  // 分类主ID（冗余字段？可合并）

  // 属性与规格
  attrList: [],
  // 提交用规格定义
  attrValueList: [
  // 提交用规格值列表
  {
    image: '',
    brokerage: 0,
    brokerageTwo: 0,
    firstAmount: 0,
    secondAmount: 0,
    price: 0.01,
    vipPrice: 0.01,
    cost: 0.01,
    otPrice: 0,
    stock: 0,
    barCode: '',
    itemNumber: '',
    weight: 0,
    volume: 0,
    cdkeyId: null,
    cdkeyLibraryName: '',
    expand: '',
    isShow: true
  }],
  attrs: [],
  // 渲染用规格

  // 营销相关
  selectRule: '',
  isSub: false,
  commissionType: 1,
  // 佣金类型: 1=百分比, 2=固定金额
  isPaidMember: false,
  couponIds: [],
  coupons: [],
  guaranteeIds: '',
  // 保证金方案ID（可用逗号分隔）
  guaranteeIdsList: null,
  // 保证金方案列表

  // 配送方式
  deliveryMethodList: ['2'],
  // 配送方式列表（默认快递）
  deliveryMethod: '',
  // 当前选中配送方式

  // 审核与上架
  isAutoSubmitAudit: false,
  // 自动提交审核
  isAutoUp: false,
  // 自动上架

  // 退款配置
  refundSwitch: true,
  isPresale: false,
  presaleStartTime: '',
  presaleEndTime: '',
  // 模板/表单
  tempId: '',
  systemFormId: null,
  // 扩展配置
  ext: {
    reservation: '是',
    // 是否支持预约
    limitRule: '',
    // 限购规则
    productReturn: '',
    // 是否支持退货
    runTime: '08:00:00-17:30:00',
    // 可售时间
    topKnow: '',
    // 顶部须知
    limitUse: '' // 限用规则
  },
  // 其他
  lastDay: '',
  header: []
};

// 商品字段标题
var objTitle = exports.objTitle = {
  price: {
    title: '售价（元）'
  },
  vipPrice: {
    title: '会员价（元）'
  },
  cost: {
    title: '成本价（元）'
  },
  otPrice: {
    title: '划线价（元）'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编码'
  },
  itemNumber: {
    title: '商品条码'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  },
  brokerage: {
    title: '一级返佣(%)'
  },
  brokerageTwo: {
    title: '二级返佣(%)'
  }
};